/**
 * COMPONENTE DE REGISTRO - GROWLY
 * Tela de cadastro de novos usuários
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../utils/api'; // ✅ IMPORTAR API

const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        password: '',
        company: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // ✅ USAR API AO INVÉS DE FETCH
            const response = await api.post('/auth/register', formData);

            if (response.data.success) {
                // Salvar token e usuário
                localStorage.setItem('token', response.data.token);
                localStorage.setItem('user', JSON.stringify(response.data.user));
                
                console.log('✅ Registro realizado com sucesso');
                
                // Redirecionar para onboarding
                navigate('/onboarding');
            } else {
                setError(response.data.error || 'Erro ao criar conta');
            }
        } catch (error) {
            console.error('❌ Erro no registro:', error);
            // ✅ TRATAMENTO DE ERRO MELHORADO
            setError(error.response?.data?.error || 'Erro de conexão com servidor');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="register-container">
            <div className="register-box">
                <h2>🎯 Criar Conta Growly</h2>
                <p className="trial-badge">7 dias grátis - sem cartão</p>
                
                {error && (
                    <div className="error-message">
                        ❌ {error}
                    </div>
                )}

                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Nome completo:</label>
                        <input
                            type="text"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            required
                            placeholder="Seu nome"
                        />
                    </div>

                    <div className="form-group">
                        <label>Email:</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            required
                            placeholder="seu@email.com"
                        />
                    </div>

                    <div className="form-group">
                        <label>Senha:</label>
                        <input
                            type="password"
                            name="password"
                            value={formData.password}
                            onChange={handleChange}
                            required
                            minLength="6"
                            placeholder="Mínimo 6 caracteres"
                        />
                    </div>

                    <div className="form-group">
                        <label>Empresa (opcional):</label>
                        <input
                            type="text"
                            name="company"
                            value={formData.company}
                            onChange={handleChange}
                            placeholder="Nome da empresa"
                        />
                    </div>

                    <button 
                        type="submit" 
                        disabled={loading}
                        className="btn-primary"
                    >
                        {loading ? 'Criando conta...' : 'Começar teste grátis'}
                    </button>
                </form>

                <p className="login-link">
                    Já tem conta? 
                    <a href="/login">Fazer login</a>
                </p>
            </div>
        </div>
    );
};

export default Register;